import styled from 'styled-components';

import {mixins} from '@edna/components/styles';
import {TSize} from '@edna/components/types';
import BaseAddIcon from '@edna/icons/add.svg';

import {MinusIcon as BaseMinusIcon} from 'src/icons';

export const Container = styled.div`
  ${mixins.stack({size: '1', direction: 'ROW', align: 'center'})}
`;

export const Text = styled.div`
  white-space: nowrap;

  text-transform: lowercase;

  &::first-letter {
    text-transform: uppercase;
  }
`;

type TIconProps = {
  size?: TSize;
};

const getIconStyle = ({size}: TIconProps) => mixins.wh(size === 'S' ? '12px' : '16px');

export const AddIcon = styled(BaseAddIcon)<TIconProps>`
  flex-shrink: 0;
  ${getIconStyle};
`;

export const MinusIcon = styled(BaseMinusIcon)<TIconProps>`
  flex-shrink: 0;
  ${getIconStyle};
`;
